<template>
	<div class="read">
		<div class="read__label">{{ label }}</div>
		<div class="read__value">
			<slot>{{ value || '—' }}</slot>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		label: String,
		value: [String, Number]
	}
};
</script>

<style lang="scss" scoped>
.read {
	position: relative;
	height: 52px;

	&__label {
		position: absolute;
		top: 4px;
		left: 0;
		font-size: 11px;
		color: #888;
		text-transform: uppercase;
		letter-spacing: 0.5px;
	}

	&__value {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 6px;
		font-size: 14px;
		line-height: 1.3;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
}
</style>
